<template>
    <div>
      <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="60%" top="5vh">
        <baidu-map @moving="syncCenterAndZoom" @moveend="syncCenterAndZoom" @zoomend="syncCenterAndZoom" class="bm-view" :center="center"
          :zoom="zoom" :scroll-wheel-zoom="true" @click="getClickInfo">
          <bm-marker :position="{lng: center.lng, lat: center.lat}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
          </bm-marker>
          <bm-control :offset="{width: '10px', height: '10px'}">
            <bm-auto-complete v-model="keyword" :sugStyle="{zIndex: 9999}">
              <input type="text" placeholder="请输入搜索关键字" class="serachinput">
            </bm-auto-complete>
          </bm-control>
          <bm-local-search :keyword="keyword"  :page-capacity="100" :auto-viewport="true" style="width:0px;height:0px;overflow: hidden;"></bm-local-search>
        </baidu-map>
        {{ address }}
        <div class="btnBox">
          <el-button size="medium" type="primary" @click="confirm">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  <script>
  export default {
    data: function () {
      return {
        dialogVisible: this.value, //弹框显隐
        keyword: "", //搜索关键字
        center: { lng: 116.404555, lat: 39.915599 }, //经纬度
        zoom: 13, //缩放级别
        address: "", //详细地址
        point: { lng: 116.404555, lat: 39.915599 }, //经纬度
      };
    },
    props: {
      value: Boolean,
    },
  
    methods: {
      // 打开弹框
      revealShow() {
        this.dialogVisible = true;
      },
      // 点击地图
      getClickInfo(e) {
        this.center.lng = Number(e.point.lng).toFixed(6);
        this.center.lat = Number(e.point.lat).toFixed(6);
        this.geocAddress(e.point);
      },
      // 地图缩放、地图缩放、移动过程中持续触发
      syncCenterAndZoom(e) {
        const { lng, lat } = e.target.getCenter();
        this.center.lng = Number(lng).toFixed(6);
        this.center.lat = Number(lat).toFixed(6);
        this.zoom = e.target.getZoom();
        this.geocAddress(e.target.getCenter());
      },
      // 逆向解析地址
      geocAddress(point) {
        let that = this;
        debugger
        var geoc = new BMap.Geocoder();
        geoc.getLocation(point, function (geocInfo) {
          if (geocInfo) {
            let detailsInfo = geocInfo.addressComponents;
            debugger
            let address =
              detailsInfo.province +
              detailsInfo.city +
              detailsInfo.district +
              detailsInfo.street +
              detailsInfo.streetNumber;
            if (geocInfo.surroundingPois.length > 0) {
              address = address + geocInfo.surroundingPois[0].title;
            }
            that.address = address;
            that.point = point;
          }
        });
      },
      // 确认
      confirm() {
        this.dialogVisible = false;
        this.$emit("confirmOn", this.point, this.address);
      },
    },
  };
  </script>
   
  <style scoped>
  .bm-view {
    width: 100%;
    height: 60vh;
  }
  .serachinput {
    margin: 10px;
    width: 300px;
    border: none;
    border-radius: 4px;
    padding: 0px 10px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #dcdfe6;
    color: #606266;
  }
  .btnBox {
    margin-top: 20px;
    display: flex;
    justify-content: right;
  }
  /* 去除百度地图的图标 根据实际情况看是否要加样式穿透 */
  /* ::v-deep .anchorBL {
    display: none !important;
  } */
  </style>
  